import urls from './urls';
import { axiosPut, getSourceId } from './common';

export function updateLanguagePreference(emailAddress, language, table, callback, err) {
  const request = {
    sourceId: getSourceId(),
    emailAddress,
    langPref: language
  };

  axiosPut({
    url: urls.UPDATE_LANGUAGE,
    data: request,
    callback,
    err,
  });
}
